import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";

export default class EditFaseDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {this.props.faseObject
            ? languages.structure.editFase
            : languages.structure.addFase}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            <TextField
              autoFocus
              margin="dense"
              label={languages.general.name}
              value={this.props.name}
              name="name"
              onChange={this.props.handleChange}
              type="text"
              fullWidth
            />
            <TextField
              autoFocus
              margin="dense"
              multiline
              label={languages.structure.description}
              value={this.props.description}
              name="description"
              onChange={this.props.handleChange}
              type="text"
              fullWidth
              style={{ marginTop: 20 }}
            />
            {Object.keys(this.props.tournament.scoringTypes || {}).length >
              0 && (
              <FormControl style={{ width: "100%", marginTop: 20 }}>
                <InputLabel style={{ width: "100%" }} htmlFor="scoreType">
                  {languages.structure.scoring}
                </InputLabel>
                <Select
                  style={{ maxWidth: "100%" }}
                  value={this.props.scoreType}
                  onChange={this.props.handleChange}
                  inputProps={{
                    name: "scoreType",
                    id: "scoreType",
                  }}
                >
                  {this.props.showMultiple && (
                    <MenuItem disabled value={"multiple"}>
                      {languages.structure.multiple2}
                    </MenuItem>
                  )}
                  <MenuItem value={"default"}>
                    {languages.structure.scoring + " 1"}
                  </MenuItem>
                  {Object.keys(this.props.tournament.scoringTypes)
                    .sort((a, b) => a - b)
                    .map((key, i) => {
                      return (
                        <MenuItem key={key} value={key}>
                          {languages.structure.scoring +
                            " " +
                            (i + 2).toString()}
                        </MenuItem>
                      );
                    })}
                </Select>
                <FormHelperText>
                  {languages.structure.scoreTypeOverwriteWarning}
                </FormHelperText>
              </FormControl>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
            >
              {this.props.faseObject
                ? languages.general.save
                : languages.general.add}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
